module.exports = __webpack_public_path__ + "img/neckline length.13285525.png";